import React, { Component, createContext, useState, ReactNode } from "react";
import ApiService from "../api/api.service";
import { useQuery } from "react-query";



interface Props {
  children: ReactNode;
}

interface State {
}

interface TenantRegistration {
  tenantRegistration: any;
  tenant_config: any;
  connection_creds: any;
  loader_creds: any;
}

export default class TenantService {
  private static instance: TenantService;

  public static getInstance(): TenantService {
    if (!TenantService.instance) {
        TenantService.instance = new TenantService();
    }

    return TenantService.instance;
  }

  constructor() {
  }

  public async getTenantRegistration() {
        // checks existence of tenant for authenticated user.
        const response = await ApiService.getInstance().request('GET', '/tenant-config/init') as TenantRegistration;
        return response;
  }

}

export const useTenantRegistration = () => {
  return useQuery(['tenant_registration'], async () => {
    return TenantService.getInstance().getTenantRegistration();
  });
}

